import { Vue, prop } from 'vue-class-component';
import { Inject } from 'vue-property-decorator';
import { CoreModuleContext } from '@/store/core';
import { PpSourceType } from '@/types/core';
import { CoreService, ServiceContainer } from '@/services';
import { WriteupModuleContext } from '@/store/writeup';
import { AMPLITUDE_LABELS } from '@/common';
import { SdEvents } from '@/types/sd-events';
import { DealType } from '@/types/writeup';

class WidgetStandardProps {
	vin = prop<string>({ default: undefined });

	vdpUrl = prop<string>({ default: undefined });

	vehicleImageUrl = prop<string>({ default: undefined });

	entryPoint = prop<string>({ default: undefined });

	custom = prop<string>({ default: undefined });

	sourceType = prop<PpSourceType>({ default: 'not-provided' });

	isVDP = prop<boolean>({ default: undefined });
}

export default class WidgetStandard extends Vue.with(WidgetStandardProps) {
	@Inject() readonly coreModule!: CoreModuleContext;

	@Inject() readonly coreService!: CoreService;

	@Inject() readonly serviceContainer!: ServiceContainer;

	@Inject() readonly writeupModule!: WriteupModuleContext;

	text = 'Calculate Your Payment';

	isVisible = false;

	get display() {
		return this.vdpUrl?.length && this.vin?.length && !this.coreModule.state.isError && this.isVisible;
	}

	get dealType() {
		return this.writeupModule.getters.dealType;
	}

	get writeUpUpdatingStatus() {
		return this.writeupModule.getters.isWriteupUpdating;
	}

	async mounted() {
		await this.checkButtonVisibility();
		this.updateButtonText();

		if (!this.display) {
			return;
		}
		if (this.isVDP) {
			this.coreService.warmup(this.vin);
		} else {
			this.coreService.warmupInViewport(this.$el, this.vin);
		}
	}

	get writeupId() {
		return this.writeupModule.getters.writeupObject?.writeupId;
	}

	openPrecisePrice() {
		if (!this.writeupId) this.writeupModule.mutations.setWriteupUpdating();
		this.coreModule.actions.runApp({
			vin: this.vin,
			vdpUrl: this.vdpUrl,
		});

		this.coreModule.actions.loadWebsite()
			.then(() => {
				this.triggerEvent();
				localStorage.DealerDomain = this.coreModule.getters.website?.domain;
			});
		this.triggerShiftDigitalEvent();
	}

	triggerEvent() {
		const action = this.sourceType === 'srp' ? 'ViewSRP' : 'ViewVDP';

		const eventData = {
			CTA: this.text,
			Action: action,
			Label: AMPLITUDE_LABELS.nameOfCTA,
		};

		this.coreModule.actions.sendEvent(eventData);
	}

	triggerShiftDigitalEvent() {
		this.writeupModule.actions.trackSdEvent(SdEvents.LoadPrecisePrice);
		this.writeupModule.actions.setPpLoaded();
	}

	private updateButtonText() {
		this.text = this.coreModule.getters.config.buttonText ? this.coreModule.getters.config.buttonText : 'Calculate Your Payment';
	}

	checkButtonVisibility() {
		this.coreModule.actions.checkButtonVisibility(this.vin)
			.then(res => {
				this.isVisible = res;
			});
	}
}
